export default "__VITE_ASSET__C17i9MVe__"